import script from "./GamesContent1.vue?vue&type=script&setup=true&lang=js"
export * from "./GamesContent1.vue?vue&type=script&setup=true&lang=js"

import "./GamesContent1.vue?vue&type=style&index=0&id=1e0e6c3a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e0e6c3a"]])

export default __exports__